<template>
  <div>
    <div class="justify-content-between d-flex mb-4">
      <div class="d-flex align-items-center">
        <div class="filter refresh" @click="refreshData">
          <span>Refresh</span>
          <svg
            :class="{ rotate: refresh }"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#A5A5A5"
          >
            <path
              d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
        <div class="filter calendar" @click="toggleFilter">
          <img src="./../assets/icons/calendar.svg" alt="" />
          <span>Today</span>
          <img src="./../assets/icons/arrow-down.svg" alt="" />
        </div>
      </div>
      <div class="d-flex align-items-center">
        <span>Show</span>
        <div class="filter show">
          <slot name="select-entry"></slot>
        </div>
        <slot name="entries-no"></slot>
      </div>
    </div>
    <div
      id="filterModal"
      class="filter-modal"
      :class="{ 'filter-fade': showFilterModal }"
    >
      <div class="filter-param">
        <span>Date</span>
        <!-- <slot name="choose-date" :closeModal="toggleFilter"></slot> -->
        <div class="d-flex">
          <b-form-datepicker
            placeholder="Start date"
            locale="en"
            class="filter-date mr-4"
            :max="today"
            @input="
              enableEndDate();
              applyFilter();
            "
            v-model="startDate"
          ></b-form-datepicker>
          <b-form-datepicker
            placeholder="End date"
            locale="en"
            class="filter-date"
            :disabled="disabled"
            :min="startDate"
            :max="today"
            @input="
              applyFilter();
              toggleFilter();
            "
            v-model="endDate"
          ></b-form-datepicker>
        </div>
      </div>
    </div>
    <slot name="table"></slot>
    <slot name="table-2"></slot>
    <slot name="table-3"></slot>
    <slot name="table-4"></slot>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      showFilterModal: false,
      startDate: "",
      endDate: "",
      disabled: true,
      refresh: false,
      today: moment(Date.now()).format("YYYY-MM-DD"),
    };
  },
  computed: mapState({
    loading: (state) => state.topAgents.loading,
  }),
  methods: {
    ...mapActions({
      topPinpad: "topAgents/getTopPinpad",
      topPos: "topAgents/getTopPos",
      topTransfer: "topAgents/getTopTransfer",
      topAccount: "topAgents/getTopAccount",
      refreshAllData: "topAgents/refresh",
    }),
    refreshData() {
      console.log("refresh");
      if (this.startDate.length < 1 || this.endDate.length < 1) {
        this.refreshAllData();
      }
      if (this.startDate.length > 1 && this.endDate.length > 1) {
        this.refresh = true;
        this.applyFilter();
        setTimeout(() => {
          this.refresh = false;
        }, 2000);
      }
    },
    applyFilter() {
      if (this.endDate.length > 1) {
        this.topPinpad({
          startDate: this.startDate,
          endDate: this.endDate,
        });
        this.topPos({
          startDate: this.startDate,
          endDate: this.endDate,
        });
        this.topTransfer({
          startDate: this.startDate,
          endDate: this.endDate,
        });
        this.topAccount({
          startDate: this.startDate,
          endDate: this.endDate,
        });
      }
    },
    clearFilter() {
      (this.startDate = ""), (this.endDate = "");
    },
    enableEndDate() {
      this.disabled = false;
    },
    toggleFilter() {
      this.showFilterModal = !this.showFilterModal;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-modal {
  width: fit-content;
}
.calendar img {
  padding: 0.65rem;
}
</style>
